export default __webpack_public_path__ + "static/media/LF.626d8c22.png";